// extracted by css-extract-rspack-plugin
export default {"cls1":"EdgePill-cls1_LG6","cls2":"EdgePill-cls2_8ZC EdgePill-cls1_LG6","dock-pulse":"EdgePill-dock-pulse_8if"};